import { getEProvinceList } from '@if/core/types'
import { ControlledSelect, ControlledTextField, useTranslatedOptionEnum } from '@if/mui'
import { Grid, Stack, Typography } from '@mui/material'
import { Control, FieldValues } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { NewLoanDtoSchemaType } from './loan-form-schema'

interface Props<TFieldValues extends FieldValues> {
  control: Control<NewLoanDtoSchemaType, TFieldValues>
  isBorrower: boolean
}

const BorrowerAddressInputRow = <TFieldValues extends FieldValues = FieldValues>({
  control,
  isBorrower,
}: Props<TFieldValues>) => {
  const { t } = useTranslation()
  const suffix = isBorrower ? 'borrower' : 'coBorrower'
  const stateIsoOptions = useTranslatedOptionEnum('EProvince', getEProvinceList(), 'enum')

  return (
    <>
      <Grid size={12}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">{t('loan.address.address')}</Typography>
        </Stack>
      </Grid>
      <Grid size={4}>
        <ControlledTextField
          control={control}
          name={`${suffix}.address.civicNumber`}
          label={t('loan.address.civicNumber')}
        />
      </Grid>
      <Grid size={4}>
        <ControlledTextField control={control} name={`${suffix}.address.street`} label={t('loan.address.street')} />
      </Grid>
      <Grid size={2}>
        <ControlledTextField
          control={control}
          name={`${suffix}.address.apartment`}
          label={t('loan.address.apartment')}
        />
      </Grid>
      <Grid size={2}>
        <ControlledTextField control={control} name={`${suffix}.address.suite`} label={t('loan.address.suite')} />
      </Grid>
      <Grid size={4}>
        <ControlledTextField
          control={control}
          name={`${suffix}.address.postalCode`}
          label={t('loan.address.postalCode')}
        />
      </Grid>
      <Grid size={4}>
        <ControlledTextField control={control} name={`${suffix}.address.city`} label={t('loan.address.city')} />
      </Grid>
      <Grid size={4}>
        <ControlledSelect
          control={control}
          name={`${suffix}.address.stateIso`}
          label={t('loan.address.stateIso')}
          options={stateIsoOptions}
        />
      </Grid>
    </>
  )
}

export default BorrowerAddressInputRow
